import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityUnavailable } from '../../classes/entityunavailable.class';
import { Utils } from '../../utils.class';
import { Features } from '../auth/features';
import { RealtimeService } from '../realtime/realtime.service';
import { WebsocketService } from '../websocket/websocket.service';
import { EntitiesService } from './entities.service';
import { EntityTypeCode } from './entity-type.class';

@Injectable({ providedIn: 'root' })
export class EntityUnavailableService extends RealtimeService<EntityUnavailable> {
    constructor(
        private entitiesService: EntitiesService,
        protected websocketService: WebsocketService
    ) {
        super(websocketService, Features.EntitiesEntityUnavailable);
    }

    public itemInDaterange(entityUnavailable: EntityUnavailable, fromDate: Date, toDate: Date) {
        return Utils.entityInDaterange(entityUnavailable, fromDate, toDate);
    }

    public getTrucksAvailableForRange(fromDate: Date, toDate: Date) {
        const trucks$ = this.entitiesService.getByType(EntityTypeCode.Truck);
        const unavailable$ = this.getFilteredList(fromDate, toDate);

        return combineLatest([trucks$, unavailable$]).pipe(
            map(([trucks, unavailable]) => {
                const startTime = fromDate.getTime();
                const endTime = toDate.getTime();

                let todayTrucks = trucks
                    .filter(t => t.use_once)
                    .filter(
                        t =>
                            new Date(t.begindate).getTime() <= startTime &&
                            (t.enddate === null || new Date(t.enddate).getTime() >= endTime)
                    );

                todayTrucks = todayTrucks.filter(t => {
                    return (
                        unavailable
                            .filter(u => u.entity_id === t.id)
                            .filter(u => this.itemInDaterange(u, fromDate, toDate)).length === 0
                    );
                });

                return todayTrucks.length;
            })
        );
    }
}
